<template>
  <div class="banner_s">
    <van-row>
      <van-col span="16" style="box-sizing: border-box; padding-right: 0.2rem">
        <van-swipe :autoplay="3000">
          <van-swipe-item
            v-for="(image, index) in homeData?.banner"
            :key="image.id + 'banner'"
          >
            <router-link :to="image.link_url || '/'">
              <img
                class="img"
                :alt="image.title"
                :src="image.pic"
                width="100%"
              />
            </router-link>
          </van-swipe-item>
        </van-swipe>
      </van-col>
      <van-col span="8">
        <router-link to="/user/drawExplain">
          <img
            :src=" homeData?.img"
            width="100%"
            alt=""
          />
		  <!-- http://xiaofu2023.oss-accelerate.aliyuncs.com/img/img_lucky_home_1minute_know.9893b257.png -->
        </router-link>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { swiperSlide } from "vue-awesome-swiper";
import swiperx from "@/components/swiperx.vue";
import api from "@/request/api";
export default {
  name: "bannerCom",
  components: {
    swiperx,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions_sw: {
        autoplay: {
          delay: 3000, //时间间隔
          disableOnInteraction: false,
        },
		
        effect: "coverflow",
        slidesPerView: 1,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 200,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },
  props: {
    homeData: {
      type: Object,
      required: true,
    },
  },

};
</script>


